import {useCallback, useContext} from 'react';

import {RESPONSE_STATUSES} from '@/src/app/constants/api';
import useLoading from '@/src/hooks/useLoading';

import PopupContext from '../../../popup/utils/PopupContext';
import ChangePasswordPopupLayout from '../components/ChangePasswordPopupLayout';
import editPassword from '../utils/editPassword';

const ChangePasswordPopup = () => {
  const {closePopup} = useContext(PopupContext);
  const {isLoading, setLoading} = useLoading();

  const handleSubmitClick = useCallback(async (values, {setFieldError}) => {
    setLoading(true);
    const {status, responseBody} = await editPassword(values);
    setLoading(false);

    if (status === RESPONSE_STATUSES.SUCCESS) {
      closePopup();
    }

    if (
      responseBody &&
      responseBody.error &&
      typeof responseBody.error === 'object'
    ) {
      for (const key in responseBody.error) {
        if (Object.prototype.hasOwnProperty.call(responseBody.error, key)) {
          setFieldError(key, responseBody.error[key]);
        }
      }
    }
  }, []);

  const handleCancelClick = useCallback(() => {
    closePopup();
  }, [closePopup]);

  return (
    <ChangePasswordPopupLayout
      onSubmitClick={handleSubmitClick}
      onCancelClick={handleCancelClick}
      isLoading={isLoading}
    />
  );
};

export default ChangePasswordPopup;
